import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Text } from "grommet";
import * as React from "react";
import { MatchOutcomeViewModel } from "./MatchesStore";

import { Outcome, OutcomeColor, OutcomeIcon } from "./OutcomeIcon";

export const RenderOutcome = ({ outcome, size, reverse }: { outcome?: MatchOutcomeViewModel; size: string; reverse?: boolean }) => {
    let color = OutcomeColor(outcome);
    return outcome ? (
        <Box align="center" pad={{ horizontal: "small" }}>
            {reverse ? (
                <Box direction="row" align="center" justify="center" gap="small">
                    <Text size={size} color={color} style={{ whiteSpace: "nowrap" }}>
                        {outcome.score}
                    </Text>
                    <Text size={size} color={color}>
                        {OutcomeIcon(outcome)}
                    </Text>
                </Box>
            ) : (
                <Box direction="row" align="center" justify="center" gap="small">
                    <Text size={size} color={color}>
                        {OutcomeIcon(outcome)}
                    </Text>
                    <Text size={size} color={color} style={{ whiteSpace: "nowrap" }}>
                        {outcome.score}
                    </Text>
                </Box>
            )}

            {size !== "small" && <Text size={size}>{outcome.outcomeType}</Text>}
        </Box>
    ) : (
        <Box></Box>
    );
};
